import { Deserializable, Deserialize } from "../helpers/serialization";
import { ZoomImageTile } from "./zoom-image-tile";

export class ZoomImageDefinition extends Deserializable
{
    @Deserialize()
    public title: string;
    
    @Deserialize()    
    public author: string;
    
    @Deserialize()
    public year: string;
    
    @Deserialize()
    public id: string;
    
    @Deserialize()
    public width: number;
    
    @Deserialize()
    public height: number;
    
    @Deserialize()
    public file: string;
    
    @Deserialize()
    public tiles_x: number;
    
    @Deserialize()
    public tiles_y: number;
    
    @Deserialize()
    public offset_x: number;
    
    @Deserialize()
    public offset_y: number;
    
    @Deserialize({isArray:true})
    public tiles: ZoomImageTile[] = [];

    public tileByIndex(index:number):ZoomImageTile
    {
        for (let i = 0; i < this.tiles.length; i++)
        {
            if (this.tiles[i].index == index) return this.tiles[i];
        }
        return null;
    }
}